import React, { useEffect, useState } from 'react';
import axios from 'axios';

import TextFieldShort from '../../components/TextFieldShort';
import TextFieldLong from '../../components/TextFieldLong';
import Dropdown from '../../components/Dropdown';

import './styles.css';

import fields from './data';

const Contact = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('NA');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [confirmation, setConfirmation] = useState('');

  const handleSubmit = e => {
    const abortController = new AbortController();
    e.preventDefault();
    console.log('Clean up 1');
    axios
      .post('/api/form', {
        fullName,
        email,
        phone,
        subject,
        message,
        sent,
        confirmation,
        signal: abortController.signal,
      })
      .then(res => {
        if (res && !res.ok) {
          throw Error('Could not post to the specified endpoint.');
        }
      })
      .then(
        setFullName(''),
        setEmail(''),
        setPhone(''),
        setSubject('NA'),
        setMessage(''),
        setSent(true),
        setError(null),
        setConfirmation('Your message has been sent!')
      )
      .catch(err => {
        if (err.name === 'AbortError') {
          console.log('post aborted');
        } else {
          setError(err.message);
          setSent(false);
        }
      });
    console.log('Clean up 2');
    return abortController.abort();
  };

  // const sendMessage = () => {
  // 	this.recaptcha.execute()
  // }

  // const onResolve = () => {
  // 	this.setState({ sent: true })
  // 	console.log(this.state)
  // }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // for smoothly scrolling
    });
  }, [sent, error]);

  return (
    <div className='page-container'>
      <div className='contact-page-title'>
        <h1 className='description-large'>Contact Us</h1>
        <h2>For more information on our classes please email us at info@funlearningcompany.com and we'll get back to you as soon as possible!</h2>
      </div>
    </div>
  );
};

export default Contact;
